module.exports = __webpack_public_path__ + "static/media/ic_template_5.b2f6c1ff.png";